import React from "react";
import { env } from "build/env";
export function distance(lat1, lng1, lat2, lng2) {
  var R = 6378137; // Radius of the Earth in meters
  var rlat1 = lat1 * (Math.PI / 180); // Convert degrees to radians
  var rlat2 = lat2 * (Math.PI / 180); // Convert degrees to radians
  var difflat = rlat2 - rlat1; // Radian difference (latitudes)
  var difflon = (lng2 - lng1) * (Math.PI / 180); // Radian difference (longitudes)

  var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
  return d;
}
export var isExternalLink = url => {
  return /^(http|https):\/\//.test(url);
};
export function isEveryValueNotEmpty(obj) {
  if (obj === null || obj === undefined) return false;
  if (Object.keys(obj).length === 0) return false;
  return Object.values(obj).every(value => {
    return value !== null && value !== undefined && value !== "";
  });
}
export var removeAtIndex = (arr, index) => {
  var copy = [...arr];
  copy.splice(index, 1);
  return copy;
};
export var toggle = function (arr, item) {
  var getValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : item => item;
  var index = arr.findIndex(i => getValue(i) === getValue(item));
  if (index === -1) return [...arr, item];
  return removeAtIndex(arr, index);
};
export var handleDisabledButtonClick = () => {
  // Select all elements with the specified class
  var elements = document.querySelectorAll(".shake-incomplete");

  // Add the shake animation class to each element
  elements.forEach(element => {
    element.classList.add("uk-animation-shake");

    // Remove the class after the animation duration (assuming 1s for example)
    setTimeout(() => {
      element.classList.remove("uk-animation-shake");
    }, 1000); // Adjust time to match the duration of the uk-animation-shake
  });
};
export var replaceAllOccurrences = (str, searchValue, replaceValue) => {
  return str.replace(new RegExp(escapeRegExp(searchValue), "g"), replaceValue);
};

// Utility function to escape special characters for the regular expression
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

// Function to replace the Magento backend URL with the image base URL
export var cdnImageUrl = src => {
  return src && env.IMAGE_BASE_URL ? replaceAllOccurrences(src, env.MAGENTO_BACKEND_URL, env.IMAGE_BASE_URL) : src;
};
export var bgImage = src => "url(".concat(cdnImageUrl(src), ")");
export function getCarouselSlides(carousel) {
  var itemsSlider = carousel ? carousel.slides : null;
  var sliderBackground_Mobile = itemsSlider && itemsSlider.map((item, i) => ({
    id: item.slide_id,
    backgroundImage: bgImage(item.mobile_image ? item.mobile_image : item.desktop_image),
    title: item.heading_text,
    subtitle: item.subtitle_text,
    cta_text: item.cta_text,
    cta_url: item.cta_url,
    video: item.mobile_video && windowSize.innerWidth < 640 ? item.mobile_video : item.desktop_video
  }));
  var sliderBackground_Desktop = itemsSlider && itemsSlider.map((item, i) => ({
    id: item.slide_id,
    backgroundImage: bgImage(item.desktop_image ? item.desktop_image : item.mobile_image),
    title: item.heading_text,
    subtitle: item.subtitle_text,
    cta_text: item.cta_text,
    cta_url: item.cta_url,
    video: item.desktop_video ? item.desktop_video : item.mobile_video
  }));
  return [itemsSlider, sliderBackground_Mobile, sliderBackground_Desktop];
}
export var getArrayIntersection = arrays => {
  if (arrays.length === 0) {
    return [];
  }
  var result = arrays.shift().filter(function (v) {
    return arrays.every(function (a) {
      return a.indexOf(v) !== -1;
    });
  });
  return result;
};
export var arraysHaveSameItems = (a, b) => {
  var uniqueA = new Set(a);
  var uniqueB = new Set(b);
  if (uniqueA.size !== uniqueB.size) return false;
  for (var item of uniqueA) {
    if (!uniqueB.has(item)) {
      return false;
    }
  }
  return true;
};
export function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(window.atob(base64).split("").map(function (c) {
    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(""));
  return JSON.parse(jsonPayload);
}
export var compareArrays = (a, b) => a.length === b.length && a.every(v => b.includes(v));
export var isArraySubset = (a, b) => a.every(val => b.includes(val));
export var breakLineIfExceedsLimit = (text, limit) => {
  if (!text) return "";
  var words = text.split(" ");
  var sum = 0;
  var breakIndex = -1;
  if (words[0].length >= limit) {
    breakIndex = 1; // If the first word equals or exceeds the limit, break after it
  } else {
    for (var index = 0; index < words.length; index++) {
      var newSum = sum + words[index].length + (index > 0 ? 1 : 0); // Add 1 for the space

      if (newSum > limit) {
        breakIndex = index;
        break;
      }
      if (index < words.length - 1 && words[index + 1].length <= 3) {
        var futureSum = newSum + words[index + 1].length + 1; // Sum considering the next word
        var remainingLength = text.length - futureSum; // Total length of the remaining text

        if (futureSum > remainingLength) {
          breakIndex = index + 1;
          break;
        }
      }
      sum = newSum;
    }
  }
  if (breakIndex === -1) {
    return text; // No need to break the line
  }
  var firstLine = words.slice(0, breakIndex).join(" ");
  var secondLine = words.slice(breakIndex).join(" ");
  return /*#__PURE__*/React.createElement("div", null, firstLine, /*#__PURE__*/React.createElement("br", null), secondLine);
};
export var goToAllergens = isFastCasualStore => {
  window.open(isFastCasualStore ? "https://magento-prod.miscusi.com/pub/media/pdf/menuAllergeniFCAI2023.pdf" : "https://magento-prod.miscusi.com/pub/media/pdf/menuAllergeniCDAI2023.pdf");
};
export function getRandom(arr, n) {
  var result = new Array(n),
    len = arr.length,
    taken = new Array(len);
  if (n > len) return arr.slice();
  while (n--) {
    var x = Math.floor(Math.random() * len);
    result[n] = arr[x in taken ? taken[x] : x];
    taken[x] = --len in taken ? taken[len] : len;
  }
  return result;
}
export var removeBasenameFromPath = function () {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var string = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  if (path.startsWith(string)) {
    return path.substring(string.length);
  }
  return path;
};
export var isEmailValid = value => {
  if (!value) return false;
  return value.trim().match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) && !value.trim().endsWith(".con");
};
export var isPasswordValid = value => {
  if (!value) return false;
  var regex = new RegExp("(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!$*?@]).{8,}", "g");
  return regex.test(value);
};
export var isTelephoneNumberValid = value => {
  var stringValue = value === null || value === void 0 ? void 0 : value.toString();
  if (!stringValue) return false;
  return stringValue.trim().match(/^\+?([0-9]{1,3})?[-. ]?(\\([0-9]{1,3}\\)|[0-9]{1,3})[-. ]?([0-9]{1,4})[-. ]?([0-9]{1,4})[-. ]?([0-9]{1,4})$/) ? true : false;
};
export var isImgUrl = url => {
  return /\.(jpg|jpeg|png|gif|bmp|svg)$/i.test(url);
};